import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";
import { environment } from "../environments/environment";

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export function loggerCallback(logLevel: LogLevel, message: string) {
  //console.log(message);
}

export const msalConfig: Configuration = {
    auth: {
      clientId: environment.oidc.clientId,
      authority: environment.oidc.authority,
      redirectUri: environment.oidc.redirectUri,
      postLogoutRedirectUri: environment.oidc.logoutUri,
      clientCapabilities: ['CP1']
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
            loggerCallback,
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false,
        }      
    }
};